import { Toast } from '@vivo/vos-ui'
import { app } from '@/utils'
import { Base64 } from '@/utils/base64'
import config from '@/config'
import router from 'router'
import env from '@/utils/clientEnv'
import { stringify } from 'qs'
import { setCookie, getCookie } from '@/utils/common'
import { grouponEndPopup, vbuyEndPopup, vipFirstBuyPopup } from '@/components'
import { cubicBezier } from '@/utils/cubicBezier'
import {
  isActAllowSellReq,
  isGroupAllowedSellReq,
  isAllowedSellReq,
  getRewardResultReq,
  addCommodityReq,
  autoReceiveCouponReq,
  isVipAllowSell,
  getRedirectMoyinUrlReq
} from './api'

export default {
  getters: {
    getService(state) {
      let sSkuIds = []
      for (let key in state.selectParams.service) {
        if (state.selectParams.service[key].id) {
          sSkuIds.push(state.selectParams.service[key].id)
        }
      }
      return sSkuIds
    },
    /**
     * 已选套餐
     */
    getSuite(state, getters) {
      let bSkuIds = []
      let suiteInfo = []
      let id = ''
      if (state?.selectParams?.currentSuite?.id) {
        id = state.selectParams.currentSuite.id
        if (state.selectParams.currentSuite.mainSkuActTagCode == 'quickBuy') {
          suiteInfo.push({
            skuId: getters.skuId,
            qgActCode: state.selectParams.currentSuite.mainSkuQgActCode
          })
        }
        // 从已选中信息中遍历获取所有已选中的sku信息
        for (let i = 0; i < (state.selectParams.currentSuite.bundleSkus || []).length; i++) {
          bSkuIds.push(state.selectParams.currentSuite.bundleSkus[i].id)
          // key:skuId,value:抢购活动编码，用来判断活动状态
          if (state.selectParams.currentSuite.bundleSkus[i].actTagCode == 'quickBuy') {
            suiteInfo.push({
              skuId: state.selectParams.currentSuite.bundleSkus[i].id,
              qgActCode: state.selectParams.currentSuite.bundleSkus[i].qgActCode
            })
          }
        }
      }
      return { bSkuIds, id, suiteInfo }
    },
    getCartAddParameter(state, getters) {
      let parameter = {
        num: state.selectParams.number,
        mainSku: {
          skuId: getters.skuId
        }
      }
      // 已选赠品 不使用lastChoosedGiftIds和 giftIds参数存在——none情况【结算页使用】
      const selectedGiftIds = state.selectedGifts.find(item => item.skuId == getters.skuId)
      if(selectedGiftIds && selectedGiftIds.giftsList && selectedGiftIds.giftsList.length > 0){
        parameter.chooseGiftIds = selectedGiftIds.giftsList.join(',')
      }
      // 已选套餐
      let { id } = getters.getSuite
      if (id) {
        parameter.suiteCode = id
      }
      // 服务信息
      parameter.serviceSkuList = []
      getters.getService.forEach(ele => {
        const { id: skuId, salePrice } = state.spuInfo.commoditySvcs.find(item => item.id === ele)
        parameter.serviceSkuList.push({ skuId, salePrice })
      })

      // 获取附属商品参数
      parameter.bundleSkuList = []
      getters.getSuite.bSkuIds.forEach(ele => {
        const { id: skuId, salePrice } = state.selectParams.currentSuite.bundleSkus.find(item => item.id === ele)
        parameter.bundleSkuList.push({ skuId, salePrice })
      })
      // 加购商品
      parameter.additionSkuList = state.selectParams.additionCommodity.map(item => {
        return { skuId: item.skuId }
      })
      return parameter
    },
    getSelectParams(state, getters, { route }) {
      let data = {}
      const { skuId, goodsType, isQuickBuy } = getters
      data.skuId = skuId
      // 服务商品要带上机型参数
      if (goodsType == 3) {
        data.num = 1
        data.imei = state?.spuInfo?.commons?.imei || ''
        data.authenticationCode = state?.spuInfo?.commons?.emmcid || ''
        return data
      }
      // 数量
      data.num = state.selectParams.number

      // 已选服务
      let services = getters.getService
      if (services && services.length > 0) {
        data.sSkuIds = services
      }

      // 已选套餐
      let { id, bSkuIds } = getters.getSuite
      if (id) {
        data.id = id
        data.suiteCode = id
        data.bSkuIds = bSkuIds
      }

      // 花呗分期数
      data.installmentType = state.selectParams.fqType || 0
      data.bankCode = state.selectParams.fqBank || 0
      data.fqNum = state.selectParams.fqNum || 0

      // 是否选中镭雕
      data.laser = state.selectParams.laser || false

      // 加购商品信息
      // TODO:需要注意传参的值
      data.additionalBuySkuIds = []
      state.selectParams.additionCommodity.forEach(el => {
        data.additionalBuySkuIds.push(el.skuId)
      })

      let query = state.spuQuery || route.query
      if (query.channel == 'groupon') {
        data.grouponType = 0
      } else if (query.channel == 'lottery') {
        data.grouponType = 1
      }

      const { purchaseChannel, liveRoomId, liveSceneId } = query
      if (purchaseChannel == 1) {
        data.purchaseChannel = purchaseChannel
      }
      if (liveRoomId) {
        data.liveRoomId = liveRoomId
      }
      if (liveSceneId) {
        data.liveSceneId = liveSceneId
      }
      if (state.longitude && state.latitude) {
        data.longitude = state.longitude
        data.latitude = state.latitude
      }
      console.log(data ,'提交订单data')
      return data
    },
    // v码购code
    getVCode(state, getters, { route }) {
      let query = state.spuQuery || route.query
      return query.vCode ? query.vCode : ''
    }
  },
  actions: {
    submit({ dispatch, getters, commit, state }, params) {
      const { isAdd, isCommon, grouponId, isSpot, isRecycle, isFromRecycleHome } = params || {}
      if (isFromRecycleHome == 1) {
        commit('UPDATE_ADDRESS_NEW_FLAG', 1)
      }
      if (isRecycle) {
        dispatch('updateSelectParams', { ...state.selectParams, laser: false })
        dispatch('setFormObject', params)
      } else {
        dispatch('setFormObject', null)
      }
      if (state.isSubmiting) {
        return
      }
      commit('CHANGE_SUBMIT_STSTUS', true)
      const { isQuickBuy, isGroup, isLottery, isVipFirstBuy, getSuite } = getters
      // 套餐里带抢购直接走正常购买逻辑，添加抢购活动的判断
      if (getSuite.id && getSuite.suiteInfo.length) {
        dispatch('commonSubmit', { isAdd, isSpot, suiteInfo: getSuite.suiteInfo })
      } else if (isCommon) {
        // 有活动但是用户选择了原价购买，放到判断第一位
        dispatch('commonSubmit', { isAdd, isSpot })
      } else if (isQuickBuy) {
        // 抢购逻辑
        dispatch('quickBuySubmit', { isAdd, isFromRecycleHome })
      } else if (isGroup) {
        // 拼团逻辑
        dispatch('groupSubmit', { grouponId, channel: isLottery ? 'lottery' : 'group' })
      } else if (isVipFirstBuy) {
        // 会员优先购逻辑
        dispatch('vipFirstBuySubmit')
      } else {
        // 没有活动，正常购买，立即购买,全款预定,分期购买
        dispatch('commonSubmit', { isAdd })
      }
      // 加购需要等加购接口返回再关闭弹层
      if(!isAdd){
        // 解决iOS环境下结算页返回商详页sku选择弹层无法滚动的问题
        if (env.isIOS || env.isVivoApp) {
          commit('SHOW_SKU_SELECT', false)
        }
      }
      
    },
    async quickBuySubmit({ dispatch, getters, state, commit }, { isAdd, isEndCheck, isFromRecycleHome }) {
      const params = Object.assign({}, getters.getSelectParams, {
        vbuy: true,
        actCode: state.skuInfo.commoditySkuDiscount.commoditySkuDiscountDetail.commodityQuickBuy.promotionId
      })
      try {
        const data = await isActAllowSellReq(params)
        // 异常情况， 1 活动时间结束， 2 活动未结束，但活动库存为0， 3 其他异常情况，4 常规库存为0
        if (data.status == 1 || data.status == 2 || data.status == 4) {
          /// 抢购异常弹层
          Toast.hide()
          if (isFromRecycleHome) {
            // 验证下原价购买能不能走通
            let recyleMsg = ''
            if (getters.isAtmosphere === 0 && !!data.marketable && data.status != 4) {
              recyleMsg = '您心仪的商品价格有变动'
            } else if (data.status == 2 || data.status == 4) {
              recyleMsg = '商品已被抢光，请切换其他商品'
            } else {
              recyleMsg = '活动已结束，请切换其他商品'
            }
            app.toast(recyleMsg)
          } else {
            vbuyEndPopup({
              actSkus: data.actSkus,
              vBuyStatus: data.status,
              marketable: !!data.marketable,
              skuInfo: state.skuInfo,
              commonBuy: () => {
                dispatch('commonSubmit', { isAdd: false })
              }
            })
          }
          commit('CHANGE_SUBMIT_STSTUS', false)
        } else if (data.status == 3) {
          app.toast(data.message)
          commit('CHANGE_SUBMIT_STSTUS', false)
        } else {
          if (!isEndCheck) {
            if (isAdd) {
              // 加入购物车
              dispatch('cartAdd')
            } else {
              dispatch('submitDeal', { params })
            }
          }
        }
      } catch (e) {
        app.toast(e.msg)
        commit('CHANGE_SUBMIT_STSTUS', false)
      }
    },
    async groupSubmit({ dispatch, getters, state, commit }, { grouponId, channel }) {
      const params = Object.assign({}, getters.getSelectParams, {
        grouponId: grouponId || 0,
        promotionId:
          state.skuInfo?.commoditySkuDiscount?.commoditySkuDiscountDetail?.commodityGroupon?.promotionId ||
          state.spuInfo?.spuFirstDiscount?.promotionId ||
          0,
        channel
      })
      try {
        const res = await isGroupAllowedSellReq(params)
        const status = res.status // 0 成功， 1 活动结束， 2 活动无库存
        if (status === 0) {
          dispatch('submitDeal', { params })
        } else if (status == 1 || status == 2) {
          // 拼团结束
          grouponEndPopup({
            result: res,
            selectData: getters.getSelectParams,
            spuInfo: state.spuInfo,
            skuInfo: state.skuInfo,
            commonBuy: () => {
              dispatch('commonSubmit', { isAdd: false })
            }
          })
          commit('CHANGE_SUBMIT_STSTUS', {
            flag: false,
            interval: 0
          })
        } else {
          app.toast(res.message)
          setTimeout(() => {
            window.location.reload()
          }, 3000)
        }
      } catch (e) {
        app.toast(e.msg)
        commit('CHANGE_SUBMIT_STSTUS', false)
      }
    },
    async vipFirstBuySubmit({ dispatch, getters, state, commit }) {
      const params = Object.assign({}, getters.getSelectParams, {
        spuId: getters.spuId,
        promotionId: state.skuInfo.commoditySkuDiscount.commoditySkuDiscountDetail.commodityVipFirst.promotionId,
        channel: 'vip'
      })
      try {
        const data = await isVipAllowSell(params)
        // status状态， 0 成功， 1 活动结束 2 活动库存不足 3 购买数量超出限制 4 常规库存不足， 5 活动条件不满足
        if ([1, 2, 4, 5].includes(data.status)) {
          vipFirstBuyPopup({
            vipBuyStatus: data.status,
            skuInfo: state.skuInfo,
            isTrackClick: true,
            callback: () => {
              if (data.status == 2) {
                // 更新已缓存数据 - 库存置为0
                let storeSkuSimpleData = state.allSkuSimpleData[getters.skuId]
                if (
                  storeSkuSimpleData &&
                  storeSkuSimpleData.commoditySkuDiscount.commoditySkuDiscountDetail?.commodityVipFirst?.storeFlag
                ) {
                  storeSkuSimpleData.commoditySkuDiscount.commoditySkuDiscountDetail.commodityVipFirst.storeFlag = 0
                  commit('SET_ALL_SKU_SIMPLE_DATA', storeSkuSimpleData)
                }
                commit('UPDATE_VIP_FIRST_BUY_DISABLE', true)
              }
            }
          })
          commit('CHANGE_SUBMIT_STSTUS', {
            flag: false,
            interval: 0
          })
        } else if (data.status === 3) {
          app.toast(data.message)
          commit('CHANGE_SUBMIT_STSTUS', false)
        } else {
          if (data.marketable == 1) {
            dispatch('submitDeal', { params })
          } else {
            // 下架商品
            vipFirstBuyPopup({
              vipBuyStatus: 2,
              isTrackClick: false
            })
            commit('CHANGE_SUBMIT_STSTUS', {
              flag: false,
              interval: 0
            })
          }
        }
      } catch (e) {
        e.msg && app.toast(e.msg)
        commit('CHANGE_SUBMIT_STSTUS', false)
      }
    },
    // 正常的购买逻辑，包含：立即购买,全款预定,分期购买
    async commonSubmit({ dispatch, getters, commit }, { isAdd, isSpot, suiteInfo = null }) {
      let params = Object.assign({}, getters.getSelectParams)
      if (isSpot) {
        params.channel = 'spot'
      }
      if (suiteInfo) {
        let obj = {}
        suiteInfo.map(item => {
          obj[item.skuId] = item.qgActCode
        })
        params.skuQgCodeMap = obj
      }
      try {
        if (isAdd) {
          if (suiteInfo) {
            await isAllowedSellReq(params)
          }
          // 加入购物车
          dispatch('cartAdd')
        } else {
          await isAllowedSellReq(params)
          dispatch('submitDeal', { params })
        }
      } catch (e) {
        app.toast(e.msg)
        if (e.data === '0' || e.data === '-1') {
          // 刷新页面
          setTimeout(() => {
            app.reloadWebview()
          }, 2000)
        }
        commit('CHANGE_SUBMIT_STSTUS', false)
      }
    },
    async cartAdd({ dispatch, commit, getters, state }, req) {
      // await dispatch('autoCoupon')
      // 有值就不用重新从 getters 获取
      const reqParams = req || getters.getCartAddParameter
      commit('UPDATE_ADD_PARAMS', reqParams)
      try {
        const data = await addCommodityReq(reqParams)
        if (data && data.code == 0) {
          if (data.lineNum) {
            commit('UPDATE_ADD_PARAMS', { ...reqParams, num: data.lineNum })
          }
          commit('UPDATE_CARTID', data.cartId)
          Promise.all([getRewardResultReq(), dispatch('addCartAnim')]).then(resList => {
            const rewardData = resList[0]
            dispatch('handleShopartToast', rewardData)
          })
          // 更新app购物车
          app.updateCartNum({})
        } else {
          // 已下架，或者缺货刷新页面
          if (data.code == 2 || data.code == 3 || data.code == 5 || data.code == 11 || data.code == 14) {
            const { skuId, spuId } = getters
            dispatch('getSimpleSku', { skuId, spuId, isForce: true })
            dispatch('getDetailSku', { skuId, spuId, isForce: true })
          }
          app.toast(data.msg)
        }

      }catch(e){
        app.toast(e.msg)
      }

      commit('CHANGE_SUBMIT_STSTUS', false)
    },
    setCartAnimPosition({state,commit}){
      if(state.cartAnimPosition?.startClientRect) return
      const startDom = document.querySelector('#J_detail_cart_img')
      const endDom = document.querySelector('#J_entry_cart_icon')
      if (!startDom || !endDom) return
      const startClientRect = startDom.getBoundingClientRect()
      const endClientRect = endDom.getBoundingClientRect()
      commit('SET_CARY_ANIM_POSITION', {
        startClientRect,
        endClientRect,
        src: startDom.getAttribute('src')
      })
    },
    addCartAnim({dispatch,commit,getters, state}) {
      return new Promise(resolve=>{
        if (!getters.isNeedAddCartAnim) {
          dispatch('showSkuSelect', { isShow: false })
          dispatch('fetchCartNumber')
          resolve()
          return
        }
        try{
          const {startClientRect, endClientRect, src} = state.cartAnimPosition
          const startX = startClientRect.x + startClientRect.width / 2
          const startY = startClientRect.y + startClientRect.height / 2
          const endX = endClientRect.x + endClientRect.width / 2
          const endY = endClientRect.y + endClientRect.height / 2
          const endDom = document.querySelector('#J_entry_cart_icon')
          // 创建一个dom元素
          let imgNode = document.createElement('img')
          imgNode.setAttribute('src', src)
          imgNode.setAttribute(
            'style',
            `position:fixed;left:${startClientRect.x}px;top:${startClientRect.y}px;width:${startClientRect.width}px;height:${startClientRect.height}px;z-index:99999;`
          )
          document.body.appendChild(imgNode)

          // 记录元素实时位置
          let nowX = 0
          let nowY = 0
          const startOpacity = 1
          const endOpacity = 0
          let opacity = 1
          const startScale = 1
          const endScale = 0.2
          let scale = 1
          let besize = cubicBezier(0.17, 0.0, 0.83, 1)
          const process1Time = (20 / 60) * 1000
          const process2Time = (32 / 60) * 1000
          const process3Time = (38 / 60) * 1000
          const duration = 1000
          const transformDuration = process2Time
          const scaleDuration = process2Time - process1Time
          const opacityDuration = process3Time - process1Time
          endDom.classList.add('cartInAni')
          setTimeout(()=>{
            // 在动画落袋之后，更新购物车数量
            dispatch('fetchCartNumber')
          },process3Time)
          let startTime = +new Date()

          let move = () => {
            let changeTime = +new Date()
            if (changeTime - startTime <= process1Time) {
              nowX = (((changeTime - startTime) / transformDuration) * (endX - startX)).toFixed(2)
              nowY = (besize((changeTime - startTime) / transformDuration) * (endY - startY)).toFixed(2)
            } else if (changeTime - startTime <= process2Time) {
              nowX = (((changeTime - startTime) / transformDuration) * (endX - startX)).toFixed(2)
              nowY = (besize((changeTime - startTime) / transformDuration) * (endY - startY)).toFixed(2)
              scale = (
                besize((changeTime - startTime - process1Time) / scaleDuration) * (endScale - startScale) +
                startScale
              ).toFixed(2)
              opacity = (
                besize((changeTime - startTime - process1Time) / opacityDuration) * (endOpacity - startOpacity) +
                startOpacity
              ).toFixed(2)
            } else if (changeTime - startTime <= process3Time) {
              opacity = (
                besize((changeTime - startTime - process1Time) / opacityDuration) * (endOpacity - startOpacity) +
                startOpacity
              ).toFixed(2)
            } else {
              imgNode.remove()
              scale = endScale
              opacity = endOpacity
              if (changeTime - startTime >= duration) {
                endDom.classList.remove('cartInAni')
                resolve()
                return
              }
            }
            window.requestAnimationFrame(() => {
              imgNode.style.opacity = opacity
              imgNode.style.transform = `translate3d(${nowX}px,${nowY}px,0) scale(${scale})`
              move()
              state.isShowSkuSelect && commit('SHOW_SKU_SELECT', false)
            })
          }
          move()
        }catch(e){
          resolve()
          console.log(e)
        }
      })
    },
    handleShopartToast({ dispatch, getters, state }, rewardData) {
      let message = shareRewardTip('加购', rewardData)
      if (message) {
        app.toast({
          type: 'html',
          message: message
        })
      } else {
        // 已选加购或者无加购且无推荐，直接 toast
        if (getters.isNeedAddCartAnim) {
          app.toast('加入购物车成功')
        }
      }
      dispatch('showSkuSelect', { isShow: false })
      // 加购弹层展示逻辑，1. 有加价购商品但是没选 2. 有推荐
      if (
        !getters.hasAdditionCommodity &&
        ((state.additionRecommendList && state.additionRecommendList.length > 0) || getters.hasAdditionList)
      ) {
        dispatch('changeShopcartPopupStatus', true)
      }
    },
    async autoCoupon({ getters, state }) {
      const { commodityEstimated } = getters
      let msg = ''
      let flag = true
      if (commodityEstimated?.commodityEstimatedCouponList?.length) {
        const couponUuids = commodityEstimated.commodityEstimatedCouponList.map(v => v.couponUuid).join(',')
        try {
          let queryData = { couponUuids }
          if (state.longitude || state.latitude) {
            queryData.longitude = state.longitude
            queryData.latitude = state.latitude
          }
          await autoReceiveCouponReq(queryData)
          msg = `已为您自动领取最佳优惠`
          flag = true
        } catch (err) {
          // 未登录不提示，直接跳转登录
          if (err.code === 600 || err.code === 601) {
            msg = ''
            flag = false
          } else {
            msg = err.msg
            flag = false
          }
        }
      }
      // 提示信息
      msg &&
        app.toast({
          tips: msg
        })
      return flag
    },
    async submitDeal({ getters, state, dispatch, commit }, { params }) {
      // 购买或者全款预定或者秒杀

      params.jump_native = false // 强制走H5结算，不进行native拦截
      // 加入source_from参数
      if (getters.source_from) {
        params.source_from = state.route.query.source_from
      }

      // 判断是否有到手价，如果有到手价，需要先领券，如果是镭雕那么先到镭雕页面
      let { commodityEstimated } = getters
      let { spotEstimatedPrice } = state
      if (params.channel === 'spot') {
        if (!params.suiteCode) {
          commodityEstimated = spotEstimatedPrice
        }
      }
      let msg = ''
      // 镭雕到手价直接走镭雕结算页
      if (params.laser && commodityEstimated?.commodityEstimatedCouponList?.length) {
        params.couponUuids = commodityEstimated.commodityEstimatedCouponList
          .filter(v => !v.hasReceived)
          .map(v => v.couponUuid)
          .join(',')
        if (state.longitude || state.latitude) {
          params.longitude = state.longitude
          params.latitude = state.latitude
        }
        if (params.purchaseChannel == 1) {
          params.channel = 'live'
        }
        dispatch('toOrderConfirm', { msg, params })
      } else {
        // 没有镭雕的到手价，要先获取到手价
        if (commodityEstimated?.commodityEstimatedCouponList?.length) {
          const couponUuids = commodityEstimated.commodityEstimatedCouponList
            .filter(v => !v.hasReceived)
            .map(v => v.couponUuid)
            .join(',')
          if (!couponUuids) {
            msg = `已为您自动领取最佳优惠`
            dispatch('toOrderConfirm', { msg, params })
          } else {
            try {
              let queryData = { couponUuids }
              if (state.longitude || state.latitude) {
                queryData.longitude = state.longitude
                queryData.latitude = state.latitude
              }
              if (params.purchaseChannel == 1) {
                queryData.channel = 'live'
              }
              await autoReceiveCouponReq(queryData)
              msg = `已为您自动领取最佳优惠`
              dispatch('toOrderConfirm', { msg, params })
            } catch (err) {
              // 未登录不提示，直接跳转登录
              if (err.code === 600 || err.code === 601) {
                commit('CHANGE_SUBMIT_STSTUS', false)
                msg = ''
              } else {
                msg = err.msg
                dispatch('toOrderConfirm', { msg, params })
              }
            }
          }
          // 提示信息
          msg &&
            app.toast({
              tips: msg
            })
        } else {
          dispatch('toOrderConfirm', { msg, params })
        }
      }
    },
    toOrderConfirm({ getters, state, commit, dispatch }, { msg, params }) {
      setTimeout(
        async () => {
          if (params.longitude) {
            params.longitude = Base64.encode(params.longitude)
          }
          if (params.latitude) {
            params.latitude = Base64.encode(params.latitude)
          }
          // 针对url中经纬度敏感信息加密
          // 可选赠品去结算赠品参数适配
          if ((state.lastChoosedGiftIds || state.giftIds) && getters.goodsType != 3) {
            params.chooseGiftIds = state.lastChoosedGiftIds || state.giftIds // 是否主动点开了赠品弹窗选择了可选赠品
            params.giftOpt = state.giftOpt
          } else if (params.chooseGiftIds) {
            // 没有赠品可选活动时，并且点开了赠品弹窗，此时删除params中的可选赠品参数
            delete params.chooseGiftIds
            delete params.giftOpt
          }
          // 服务商品
          commit('CHANGE_SUBMIT_STSTUS', false)
          if (getters.goodsType == 3) {
            toNewWebConfirmPage('/order/brokenOrder/confirm?' + paramsSerializer(params))
          } else if (getters.isMoYin) {
            // 手机壳定制商品
            const res = await getRedirectMoyinUrlReq(getters.skuId)
            location.href = res.redirectUrl
          } else if (params.laser) {
            // params.sourceReferUrl = env.isBankabc ? encodeURIComponent(location.href) : location.href
            if (env.isIOSVivoApp) {
              // 隐藏ios官网title bar
              params.hide_title = 1
            } else {
              // 隐藏官网原生app title bar
              params.commonImmersive = 1
            }
            // v码购code参数带到结算页
            if (getters.getVCode && state.spuInfo.isVcodeBuy) {
              params.vCode = getters.getVCode
            }
            toNewWebConfirmPage('/laser/confirm?' + paramsSerializer(params))
          } else {
            if (state.addressId) {
              params.addressId = state.addressId
            }
            // v码购code参数带到结算页
            if (getters.getVCode && state.spuInfo.isVcodeBuy) {
              params.vCode = getters.getVCode
            }
            // 详情页选择新地址弹窗参数带入结算页
            params.addressNewFlag = state.addressNewFlag
            // 不展示送至时 fromDetail不设置
            if (!getters.isLottery && getters.isShowLogistics && !getters.isPreTimeVip) {
              params.fromDetail = 1
            }
            // // 详情页送至展示结果带入结算页
            // if (!getters.isShowLogistics) {
            //   params.hideTimeLiness = 1
            // }

            // 结算页带入商品类型
            if (getters.goodsType == 2) {
              params.goodsType = 2
            }
            // 以旧换新结算页
            if (state.recycleFormObject?.oneStopCode) {
              params = {
                ...params,
                ...state.recycleFormObject
              }
              toNewWebRecycleConfirmPage('/order/recycle/confirm?' + paramsSerializer(params))
              return
            }
            toNewWebConfirmPage('/order/quick/confirm?' + paramsSerializer(params))
          }
        },
        // 如果是vivoApp 使用 native toast，可以跨页面提示，如果h5那么需要等待2s后在跳转
        !env.isVivoApp && msg ? 2000 : 0
      )
    },
    closeEndPopup() {
      grouponEndPopup.close()
      vbuyEndPopup.close()
      vipFirstBuyPopup.close()
    }
  }
}

/**
 * 获取分享、收藏、加入购物车赠送的积分
 */
function shareRewardTip(type, data) {
  let tip = ''
  if (data && (data.pointsReward || data.experiencesReward)) {
    if (data.pointsReward) {
      tip += data.pointsReward + '积分'
    }
    if (data.experiencesReward) {
      if (data.pointsReward) {
        tip += '+'
      }
      tip += data.experiencesReward + '经验值'
    }
    tip =
      type +
      '成功，+' +
      tip +
      '<span class="drop-gold-effect"><i></i><i></i><i></i><i></i><i></i><i></i><em class="box"></em></span>'
  }
  return tip ? `<span style="display: flex;align-items: center;white-space: nowrap;">${tip}</span>` : ''
}

function paramsSerializer(params) {
  return stringify(params, { indices: false })
}

function toNewWebConfirmPage(url) {
  app.openNewWebview({
    url: config.path.shopUrl + url
  })
}

function toNewWebRecycleConfirmPage(url) {
  app.openTopNewWebview({
    url: config.path.shopUrl + url
  })
}
